import { render } from "./About.vue?vue&type=template&id=2b72079a&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=2b72079a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dymek\\Desktop\\Projects\\Lusterka Adam\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b72079a"]])

export default __exports__